export type NotificationsState = {
    count: number
    suggest_posts: Array<{ board_key: string, post_key: string }> | null
}

export const notificationsState: NotificationsState = {
    count: 0,
    suggest_posts: null,
}
